import { useState, useRef } from 'react';
const OLLAMA_URL = `${window.location.protocol}//ollama.techni.co.kr/api/generate`;

const MODELS = [
  'bnksys/eeve:10.8b-korean-instruct-q5_k_s-v1',
  'bnksys/yanolja-eeve-korean-instruct-10.8b:latest',
  'qwen2.5:7b',
  'qwen2.5-coder:7b',
  'translategemma:4b',
  'hf.co/solang/Midm-2.0-Base-Instruct-Q4_K_M-GGUF:latest',
];

function AiGemin() {
  const [model, setModel] = useState(MODELS[0]);
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const abortRef = useRef(null);

  const handleSend = async () => {
    if (!prompt.trim()) return;

    setLoading(true);
    setResponse('');

    const controller = new AbortController();
    abortRef.current = controller;

    try {
      const res = await fetch(OLLAMA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ model, prompt, stream: true }),
        signal: controller.signal,
      });

      if (!res.ok) throw new Error(`HTTP 오류: ${res.status}`);

      const reader = res.body.getReader();
      const decoder = new TextDecoder('utf-8');

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split('\n').filter(l => l.trim());
        for (const line of lines) {
          try {
            const data = JSON.parse(line);
            if (data.response) {
              setResponse(prev => prev + data.response);
            }
          } catch (_) {}
        }
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        setResponse(`오류가 발생했습니다.\n\n${err.message}`);
      }
    } finally {
      setLoading(false);
      abortRef.current = null;
    }
  };

  const handleStop = () => {
    if (abortRef.current) abortRef.current.abort();
  };

  return (
    <div className="container py-4" style={{ maxWidth: 800 }}>
      <h4 className="mb-4">Ollama AI 채팅</h4>

      <div className="mb-3">
        <label className="form-label fw-bold">모델 선택</label>
        <select
          className="form-select"
          value={model}
          onChange={e => setModel(e.target.value)}
          disabled={loading}
        >
          {MODELS.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">질문</label>
        <textarea
          className="form-control"
          rows={5}
          placeholder="여기에 질문을 입력하세요..."
          value={prompt}
          onChange={e => setPrompt(e.target.value)}
          disabled={loading}
        />
      </div>

      <div className="d-flex gap-2 mb-4">
        <button
          className="btn btn-primary flex-grow-1"
          onClick={handleSend}
          disabled={loading || !prompt.trim()}
        >
          {loading ? (
            <><span className="spinner-border spinner-border-sm me-2" />응답 생성 중...</>
          ) : '질문 보내기 (스트리밍)'}
        </button>
        {loading && (
          <button className="btn btn-outline-danger" onClick={handleStop}>
            중지
          </button>
        )}
      </div>

      <div>
        <label className="form-label fw-bold">응답</label>
        <div
          className="border rounded p-3 bg-light"
          style={{ minHeight: 120, whiteSpace: 'pre-wrap', lineHeight: 1.7 }}
        >
          {response || '결과가 여기에 표시됩니다...'}
        </div>
      </div>
    </div>
  );
}

export default AiGemin;
